import { SectionShell } from "@/components/ui/admin/SectionShell";
import { Outlet } from "react-router-dom";

interface SectionLayoutProps {
  basePath: string;
}

export function SectionLayout({ basePath }: SectionLayoutProps) {
  return (
    <SectionShell basePath={basePath}>
      <Outlet />
    </SectionShell>
  );
}
